module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 765
// module chunks = 0